import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { Selectors } from '@americanexpress/axp-benefits-utils';

const getFilterData = (state) => fromJS(state).getIn(['modules', 'axp-benefits-view-all', 'filter']);

export const genericData = (data) => { if (!data) return {}; return data.toJS(); };

export const getFilter = createSelector(
  [getFilterData],
  genericData
);

export const getMemberData = (state) => fromJS(state).getIn(['modules', 'axp-benefits-view-all', 'data']);

export const getData = createSelector(
  [getMemberData],
  Selectors.genericData
);
